import { createContext, useContext } from 'react'
import type { ManualItineraryDeleteRequest, ManualItineraryMoveRequest, TripItineraryData } from 'tripPlanner/api/types'

export interface ItineraryScrollTarget {
  stopId: number
  dayId?: number
  itemId?: number
}

export interface ItineraryContextValue {
  itineraryData: TripItineraryData | undefined
  hasItineraryData: boolean
  multiCartId: string | undefined
  enrichingStopIds: Set<number>
  enrichingItemIds: Set<number>
  scrollTarget: ItineraryScrollTarget | undefined
  clearScrollTarget: () => void
  refetchCurrentChatItinerary: () => void
  deleteManualItineraryTarget: (target: ManualItineraryDeleteRequest) => Promise<boolean>
  moveManualItineraryItems: (request: ManualItineraryMoveRequest) => Promise<boolean>
  isManualItineraryDeletePending: boolean
  isManualItineraryMovePending: boolean
  isFlightCartMutationPending: boolean
  setFlightCartMutationPending: (pending: boolean) => void
}

export const ItineraryContext = createContext<ItineraryContextValue | undefined>(undefined)

export function useItineraryContext(): ItineraryContextValue {
  const ctx = useContext(ItineraryContext)
  if (!ctx) throw new Error('useItineraryContext must be used within TripPlannerChatProvider')
  return ctx
}

/**
 * Shared add-to-trip UI (offer-page assistant, hover cards) reads this optionally.
 * Only TripPlannerChatProvider supplies a value; other surfaces leave it undefined.
 */
export function useItineraryContextOptional(): ItineraryContextValue | undefined {
  return useContext(ItineraryContext)
}
